import React from 'react';
import SegmentShowcase from './SegmentShowcase';
import PlatformComparison from './PlatformComparison';

const NewLandingPage = () => {
  const handleGetStarted = () => {
    window.open('https://calendly.com/superhunt/45min', '_blank');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-orange-100">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex justify-between items-center">
            <div className="flex items-center">
              <div className="bg-orange-500 text-white px-4 py-2 rounded-lg font-mono text-xl font-bold">
                &lt;tod&gt;
              </div>
              <div className="ml-3">
                <span className="text-2xl font-bold text-gray-900">TOD Gigs</span>
                <div className="text-sm text-gray-600">Tech . Outreach . Dexter</div>
              </div>
            </div>
            <button
              onClick={handleGetStarted}
              className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-lg font-semibold transition-colors"
            >
              Get Started
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section - Text Only - MOVED TO TOP */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-12 leading-tight">
              Where Tech and Outreach Meet 
              <span className="text-orange-500"> Dexterous Execution</span>
            </h1>
            
            <div className="space-y-4 text-base sm:text-lg text-gray-700 mb-8 max-w-4xl mx-auto px-4">
              <div className="flex justify-start">
                <div className="space-y-4 text-left">
                  <div className="flex items-start space-x-3 sm:space-x-4 leading-relaxed">
                    <div className="bg-orange-500 text-white rounded-full w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center font-bold text-xs sm:text-sm mt-0.5 flex-shrink-0">
                      T
                    </div>
                    <div className="min-w-0 flex-1 break-words">
                      <span className="font-semibold text-orange-600">Tech</span> → the backbone of innovation.
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-3 sm:space-x-4 leading-relaxed">
                    <div className="bg-orange-500 text-white rounded-full w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center font-bold text-xs sm:text-sm mt-0.5 flex-shrink-0">
                      O
                    </div>
                    <div className="min-w-0 flex-1 break-words">
                      <span className="font-semibold text-orange-600">Outreach</span> → the bridge to people and markets.
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-3 sm:space-x-4 leading-relaxed">
                    <div className="bg-orange-500 text-white rounded-full w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center font-bold text-xs sm:text-sm mt-0.5 flex-shrink-0">
                      D
                    </div>
                    <div className="min-w-0 flex-1 break-words">
                      <span className="font-semibold text-orange-600">Dexter</span> → the steady skill & discipline of business process optimization.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row justify-center space-y-3 sm:space-y-0 sm:space-x-4 mt-10 px-4">
              <button
                onClick={handleGetStarted}
                className="bg-orange-500 hover:bg-orange-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-semibold text-base sm:text-lg transition-colors duration-200 shadow-lg hover:shadow-xl w-full sm:w-auto"
              >
                Find Expert Consultants
              </button>
              <button
                onClick={handleGetStarted}
                className="border-2 border-orange-500 text-orange-500 hover:bg-orange-500 hover:text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-semibold text-base sm:text-lg transition-all duration-200 w-full sm:w-auto"
              >
                Become a Gig Anchor
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Video Animation Section - AFTER Hero */}
      <SegmentShowcase />

      {/* Platform Comparison Section */}
      <PlatformComparison />

      {/* TPG Gigs Value Triangle */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              How We Do It : TOD Gigs Value Triangle
            </h2>
            <p className="text-xl text-gray-600">
              Our three-pillar approach to business transformation
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            {/* Consultation */}
            <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto">
                <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">Business Consultation</h3>
              <p className="text-gray-600 text-center">
                We design AI-powered business journeys tailored to your unique needs and market position, 
                creating strategic roadmaps for sustainable growth.
              </p>
            </div>

            {/* AI Agents + Hiring */}
            <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow">
              <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto">
                <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">AI Agents + Smart Hiring</h3>
              <p className="text-gray-600 text-center">
                Custom AI agents built for your business processes, combined with carefully selected 
                full-time resources aligned with your culture and delivery expectations.
              </p>
            </div>

            {/* Continuous Monitoring */}
            <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow">
              <div className="bg-orange-100 w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto">
                <svg className="w-8 h-8 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">Continuous Monitoring</h3>
              <p className="text-gray-600 text-center">
                Weekly gig delivery monitoring using smart technology and expert oversight, 
                ensuring your business scales to new heights with consistent quality.
              </p>
            </div>
          </div>

          <div className="text-center mt-12">
            <button
              onClick={handleGetStarted}
              className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors"
            >
              Start Your Transformation
            </button>
          </div>
        </div>
      </section>

      {/* Trusted by Leading Companies */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Trusted by Leading Companies
            </h2>
            <p className="text-xl text-gray-600">
              Join 100+ companies that have successfully hired 3000+ professionals
            </p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 items-center">
            {/* Client logos */}
            <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow flex items-center justify-center min-h-[5.5rem]">
              <img 
                src="/company-logos/aligned-automation.jfif" 
                alt="Client Logo" 
                className="h-16 w-full object-contain object-center filter grayscale hover:grayscale-0 transition-all duration-300"
              />
            </div>
            <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow flex items-center justify-center min-h-[5.5rem]">
              <img 
                src="/company-logos/channel-bridge.png" 
                alt="Client Logo" 
                className="h-16 w-full object-contain object-center filter grayscale hover:grayscale-0 transition-all duration-300"
              />
            </div>
            <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow flex items-center justify-center min-h-[5.5rem]">
              <img 
                src="/company-logos/chimera-logo.png" 
                alt="Client Logo" 
                className="h-16 w-full object-contain object-center filter grayscale hover:grayscale-0 transition-all duration-300"
              />
            </div>
            <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow flex items-center justify-center min-h-[5.5rem]">
              <img 
                src="/company-logos/digitinsurance.png" 
                alt="Client Logo" 
                className="h-16 w-full object-contain object-center filter grayscale hover:grayscale-0 transition-all duration-300"
              />
            </div>
            <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow flex items-center justify-center min-h-[5.5rem]">
              <img 
                src="/company-logos/nielson.jfif" 
                alt="Nielsen Logo" 
                className="h-16 w-full object-contain object-center filter grayscale hover:grayscale-0 transition-all duration-300"
              />
            </div>
            <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow flex items-center justify-center min-h-[5.5rem]">
              <img 
                src="/company-logos/goqii-logo.png" 
                alt="Client Logo" 
                className="h-16 w-full object-contain object-center filter grayscale hover:grayscale-0 transition-all duration-300"
              />
            </div>
            <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow flex items-center justify-center min-h-[5.5rem]">
              <img 
                src="/company-logos/gracenote.png" 
                alt="Client Logo" 
                className="h-16 w-full object-contain object-center filter grayscale hover:grayscale-0 transition-all duration-300"
              />
            </div>
            <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow flex items-center justify-center min-h-[5.5rem]">
              <img 
                src="/company-logos/lamdazen.jfif" 
                alt="Client Logo" 
                className="h-16 w-full object-contain object-center filter grayscale hover:grayscale-0 transition-all duration-300"
              />
            </div>
            <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow flex items-center justify-center min-h-[5.5rem]">
              <img 
                src="/company-logos/lumen.png" 
                alt="Client Logo" 
                className="h-16 w-full object-contain object-center filter grayscale hover:grayscale-0 transition-all duration-300"
              />
            </div>
            <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow flex items-center justify-center min-h-[5.5rem]">
              <img 
                src="/company-logos/microland-logo.jpg" 
                alt="Client Logo" 
                className="h-16 w-full object-contain object-center filter grayscale hover:grayscale-0 transition-all duration-300"
              />
            </div>
            <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow flex items-center justify-center min-h-[5.5rem]">
              <img 
                src="/company-logos/sheshi.jpg" 
                alt="Client Logo" 
                className="h-16 w-full object-contain object-center filter grayscale hover:grayscale-0 transition-all duration-300"
              />
            </div>
            <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow flex items-center justify-center min-h-[5.5rem]">
              <img 
                src="/company-logos/socialswag.jfif" 
                alt="Client Logo" 
                className="h-16 w-full object-contain object-center filter grayscale hover:grayscale-0 transition-all duration-300"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Updated Why Choose TOD Gigs Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Why Choose TOD Gigs?
            </h2>
            <p className="text-xl text-gray-600">
              Five core advantages that set us apart
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-orange-50 p-6 rounded-xl">
              <div className="bg-orange-500 text-white w-12 h-12 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Hunting Rockstars</h3>
              <p className="text-gray-600">
                7 of 10 rockstars are passive candidates. We've systematized talent sourcing with proven 
                record: 100+ clients, 3000+ successful hires in strategic tech-sales-ops.
              </p>
            </div>
            
            <div className="bg-orange-50 p-6 rounded-xl">
              <div className="bg-orange-500 text-white w-12 h-12 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9v-9m0-9v9" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Global Payroll Organization</h3>
              <p className="text-gray-600">
                Partnered with Antal International, India a global leader, for your payroll & compliance. 
                Candidates get job security regardless of your Series A, B, or C growth stage.
              </p>
            </div>
            
            <div className="bg-orange-50 p-6 rounded-xl">
              <div className="bg-orange-500 text-white w-12 h-12 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Full Time Gig Worker</h3>
              <p className="text-gray-600">
                Full-time gig workers ensure work is always completed on time and with quality. 
                Dedicated professionals for your success.
              </p>
            </div>
            
            <div className="bg-orange-50 p-6 rounded-xl">
              <div className="bg-orange-500 text-white w-12 h-12 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Delivery Oversight</h3>
              <p className="text-gray-600">
                Gig Anchors ensure thorough oversight of delivery sign-offs. Quality assurance 
                at every step of the process.
              </p>
            </div>
            
            <div className="bg-orange-50 p-6 rounded-xl">
              <div className="bg-orange-500 text-white w-12 h-12 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Pricing Advantage</h3>
              <p className="text-gray-600">
                Get managed gigs at self-serve platform prices (Upwork/Fiverr). Plus, 
                AI Roadmap consultation for your strategic growth.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-orange-500">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-4">
            Ready to Transform Your Business?
          </h2>
          <p className="text-xl text-orange-100 mb-8">
            Let us power you with Agentic Tech, Human + AI Outreach and Dexterous Execution.
          </p>
          <button
            onClick={handleGetStarted}
            className="bg-white text-orange-500 hover:bg-orange-50 px-8 py-4 rounded-lg font-semibold text-lg transition-colors"
          >
            Get Started Now
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8">
            {/* USA Office */}
            <div>
              <div className="flex items-center mb-4">
                <div className="bg-orange-500 text-white px-3 py-2 rounded-lg font-mono text-lg font-bold">
                  &lt;tod&gt;
                </div>
                <div className="ml-3">
                  <span className="text-xl font-bold">TOD Gigs</span>
                  <div className="text-sm text-gray-400">Tech . Outreach . Dexter</div>
                </div>
              </div>
              <div>
                <h4 className="text-lg font-semibold text-white mb-4">USA Office</h4>
                <p className="text-gray-400">
                  Harvard Business Services, Inc.
                </p>
                
                {/* Small Google Maps embed */}
                <div className="mt-4">
                  <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3127.0469!2d-75.139!3d38.774!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b8e4c7a4e3a7c7%3A0x8f4a6c5b3e2a1b8d!2sHarvard%20Business%20Services%2C%20Inc.%2C%2016192%20Coastal%20Hwy%2C%20Lewes%2C%20DE%2019958%2C%20USA!5e0!3m2!1sen!2sus!4v1638360000000!5m2!1sen!2sus"
                    width="200" 
                    height="150" 
                    style={{border: 0}} 
                    allowFullScreen="" 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"
                    className="rounded-lg"
                  />
                </div>
              </div>
            </div>
            
            {/* India Office */}
            <div>
              <h3 className="text-lg font-semibold mb-4">India Office</h3>
              <div className="text-gray-400 text-sm space-y-2">
                <p className="font-medium">BHIVE Premium HSR Campus</p>
                <p>BHIVE Workspace - No.112, AKR Tech Park,</p>
                <p>"A" and "B" Block, 7th Mile Hosur Rd,</p>
                <p>Krishna Reddy Industrial Area,</p>
                <p>Bengaluru, Karnataka 560068, India</p>
                <p className="mt-3">
                  <a 
                    href="https://maps.app.goo.gl/qxUd6jmNaQqYc1SZ8" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-orange-400 hover:text-orange-300 font-medium"
                  >
                    Locate us here →
                  </a>
                </p>
              </div>
            </div>
            
            {/* Links */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Explore More</h3>
              <div className="text-gray-400 text-sm">
                <a 
                  href="https://superhunt.ai/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-orange-400 hover:text-orange-300 font-medium inline-block leading-relaxed"
                >
                  <span className="block">Smart Hiring and Sales Automation</span>
                  <span className="block">with SuperHunt.ai →</span>
                </a>
                <div className="mt-4">
                  <a 
                    href="https://superhunt.ai/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-block hover:opacity-80 transition-opacity"
                  >
                    <div className="bg-white p-1 rounded-lg inline-block">
                      <img 
                        src="/company-logos/SuperHunt%20Logo.png"
                        alt="SuperHunt"
                        className="h-20 w-auto object-contain"
                      />
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2025-26 TOD Gigs Inc. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default NewLandingPage;